export const SET_FIRM_NAME_AND_LOGO = '@@FIRM/NAME_AND_LOGO';
